export type TextareaSelection = {
  value: string;
  selectionStart: number;
  selectionEnd: number;
};

export function insertAtCursor(
  { value, selectionStart, selectionEnd }: TextareaSelection,
  insert: string,
): { nextValue: string; selectionStart: number; selectionEnd: number } {
  const nextValue =
    value.slice(0, selectionStart) + insert + value.slice(selectionEnd);
  const cursor = selectionStart + insert.length;
  return { nextValue, selectionStart: cursor, selectionEnd: cursor };
}

export function wrapSelection(
  sel: TextareaSelection,
  before: string,
  after: string,
  placeholder = '',
): { nextValue: string; selectionStart: number; selectionEnd: number } {
  const { value, selectionStart, selectionEnd } = sel;
  const selected = value.slice(selectionStart, selectionEnd) || placeholder;
  const wrapped = before + selected + after;
  const nextValue =
    value.slice(0, selectionStart) + wrapped + value.slice(selectionEnd);
  const start = selectionStart + before.length;
  const end = start + selected.length;
  return { nextValue, selectionStart: start, selectionEnd: end };
}

export function prefixLines(
  sel: TextareaSelection,
  prefix: string,
): { nextValue: string; selectionStart: number; selectionEnd: number } {
  const { value, selectionStart, selectionEnd } = sel;
  const lineStart = value.lastIndexOf('\n', selectionStart - 1) + 1;
  const lineEndRaw = value.indexOf('\n', selectionEnd);
  const lineEnd = lineEndRaw === -1 ? value.length : lineEndRaw;
  const block = value.slice(lineStart, lineEnd);
  const lines = block.split('\n');
  const prefixed = lines.map((line) => prefix + line).join('\n');
  const nextValue = value.slice(0, lineStart) + prefixed + value.slice(lineEnd);
  const delta = prefixed.length - block.length;
  return {
    nextValue,
    selectionStart: selectionStart + prefix.length,
    selectionEnd: selectionEnd + delta,
  };
}

export function applyHeading(
  sel: TextareaSelection,
  level: 1 | 2 | 3,
): { nextValue: string; selectionStart: number; selectionEnd: number } {
  const prefix = '#'.repeat(level) + ' ';
  return prefixLines(sel, prefix);
}

export function parseUploadedUrl(res: unknown): string {
  if (typeof res === 'string') return res;
  const r = res as Record<string, unknown>;
  if (r?.data && typeof r.data === 'object' && r.data !== null) {
    const d = r.data as Record<string, unknown>;
    if (typeof d.data === 'string') return d.data;
    if (d.data && typeof d.data === 'object') {
      const inner = d.data as Record<string, unknown>;
      if (typeof inner.url === 'string') return inner.url;
      if (typeof inner.path === 'string') return inner.path;
    }
    if (typeof d.url === 'string') return d.url;
    if (typeof d.path === 'string') return d.path;
  }
  if (typeof r?.data === 'string') return r.data;
  if (typeof r?.url === 'string') return r.url;
  if (typeof r?.path === 'string') return r.path;
  return '';
}

export function markdownForFile(name: string, url: string, isImage: boolean): string {
  const safeName = name.replace(/[\[\]()]/g, '');
  return isImage ? `![${safeName}](${url})` : `[${safeName}](${url})`;
}
